import { useState } from "react";
import { Icon } from "../icons";
import HeaderSubMenu from "./HeaderSubMenu";

const HeaderMenuItem = (props) => {
  const {
    menu,
    link,
    icon,
    subMenuItems,
    app = "tenken",
    hasNotifications = false,
  } = props;
  const textColorMenu =
    app === "tenken"
      ? "text-white group-hover:text-[#75b5e9]"
      : "text-[#E6BE40] group-hover:text-[#FFD966]";
  const widthMenu =
    app === "tenken"
      ? "xl:max-w-[180px] lg:max-w-[150px] max-w-[95px] truncate"
      : "";
  const [ touch, setTouch ] = useState(false);
  const menuClass = `${textColorMenu} ${widthMenu}`;
  let hasSubMenu = false;
  if (subMenuItems) {
    hasSubMenu = true;
  }
  const menuLink = link ? link : "#";
  const focus = (e) => {
    e.target.closest("div").focus();
  };
  return (
    <div
      className={`group ${hasSubMenu && "relative z-50"}`}
    //   onTouchStart={e => setTouch(true)}
    //   onTouchEnd={e => setTouch(false)}
    //   onMouseLeave={e => setTouch(false)}
    //   onMouseEnter={e => setTouch(true)}
      onClick={e => setTouch(!touch)}
      onBlur={e => setTouch(false)}
    >
      <a href={menuLink} className="flex flex-row items-center">
        <Icon name={icon} className="mr-[4px] lg:w-8 lg:h-8 w-7 h-7" />
        {hasNotifications && (
          <span className="w-[10px] h-[10px] bg-[#F97066] top-0 border rounded-lg absolute z-1000"></span>
        )}

        <span className={`${menuClass} lg:text-base text-[15px]`}>{menu}</span>
        {hasSubMenu && <Icon name="chevron-down" width="20px" height="20px" />}
      </a>
      {hasSubMenu && <HeaderSubMenu subMenuItems={subMenuItems} touch={touch} />}
    </div>
  );
};

export default HeaderMenuItem;
